import { CommonModule } from "@angular/common";
import { Component, inject } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { DocumentableType } from "@models/enums/documentable-type.enum";
import { TaskType } from "@models/task-request";
import { AdminTasksService } from "@services/admin-tasks.service";
import { CommentsService } from "@services/comments.service";
import { DocumentsService } from "@services/documents.service";
import { SkeletonModule } from "primeng/skeleton";
import { BehaviorSubject, EMPTY, forkJoin, switchMap } from "rxjs";
import { AppLayoutComponent } from "../../../shared/components/app-layout/app-layout.component";
import { PageHeaderComponent } from "../../../shared/components/page-header/page-header.component";
import { BankAccountInfoCardComponent } from "./bank-account-info-card/bank-account-info-card.component";
// TODO: confirmar se a justificativa enviada pelo produtor será exibida na solicitação.
// import { CancellationInfoCardComponent } from "./cancellation-info-card/cancellation-info-card.component";
import { EventInfoCardComponent } from "./event-info-card/event-info-card.component";
import { TaskCommentsComponent } from "./task-comments/task-comments.component";
import { TaskInfoCardComponent } from "./task-info-card/task-info-card.component";

@Component({
  selector: "app-solicitation-detail-page",
  imports: [
    CommonModule,
    AppLayoutComponent,
    PageHeaderComponent,
    SkeletonModule,
    TaskInfoCardComponent,
    EventInfoCardComponent,
    // CancellationInfoCardComponent,
    BankAccountInfoCardComponent,
    TaskCommentsComponent,
  ],
  templateUrl: "./solicitation-detail-page.component.html",
  styleUrl: "./solicitation-detail-page.component.scss",
})
export class SolicitationDetailPageComponent {
  readonly TaskType = TaskType;

  private readonly _route = inject(ActivatedRoute);
  private readonly _adminTasksService = inject(AdminTasksService);
  private readonly _commentsService = inject(CommentsService);
  private readonly _documentsService = inject(DocumentsService);
  private readonly _router = inject(Router);

  private readonly _refreshComments$ = new BehaviorSubject<void>(undefined);

  private get _taskId(): number {
    return Number(this._route.snapshot.paramMap.get("id"));
  }

  task$ = this._route.paramMap.pipe(
    switchMap((params) =>
      this._adminTasksService.getById(Number(params.get("id"))),
    ),
  );

  comments$ = this._refreshComments$.pipe(
    switchMap(() => this._commentsService.getAll("AdminTask", this._taskId)),
  );

  goBack() {
    this._router.navigate(["/solicitations"]);
  }

  handleCommentSubmit(event: { message: string; files: File[] }) {
    const comment$ = this._commentsService.create({
      commenter: 0,
      body: event.message,
      commentable_id: this._taskId,
      commentable_type: "AdminTask",
    });

    comment$
      .pipe(
        switchMap((comment) => {
          const uploads$ = event.files.map((file) =>
            this._documentsService.upload(
              DocumentableType.COMMENT,
              comment.id,
              file,
            ),
          );
          return uploads$.length ? forkJoin(uploads$) : EMPTY;
        }),
      )
      .subscribe({
        complete: () => this._refreshComments$.next(),
      });
  }
}
